import { type ITopOfferSellersQuery } from 'application/querySchemas/ITopOfferSellersQuery';
import { type ICompanyUserTokenRepository } from 'application/repositorySchemas/ICompanyUserTokenRepository';
import { type ITopOfferSellersClient, IGetResponse } from 'interfaceAdapter/gatewaySchemas/ITopOfferSellersClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class TopOfferSellersQuery implements ITopOfferSellersQuery {
    constructor(
        @inject('ICompanyUserTokenRepository')
        public readonly companyUserToken: ICompanyUserTokenRepository,
        @inject('ITopOfferSellersClient')
        public readonly topOfferSellersClient: ITopOfferSellersClient,
    ) {}

    public async fetchList(): Promise<IGetResponse['data']> {
        const { data, message } = await this.topOfferSellersClient.get({
            token: this.companyUserToken.get() || '',
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}
